import React from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Fragment } from "react";
import Loader from 'react-loader-spinner'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Papa from 'papaparse';

import {
	Card,
	CardBody,
	Col,
	Row,
	Input,
	Button,
	ButtonGroup,
	Alert,
	Fade
} from 'reactstrap';

import 'react-table-v6/react-table.css'
import {
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from './shipment-products';
import {
	buildShipmentDateRows,
	applyShipmentDateSaveErrors,
	getShipmentDateSaveErrors,
	getShipmentDateRequestBody,
	validateShipmentDateHeaders
} from './batch-shipment-date-helpers';

import csvPlaceholder from '../../../assets/images/csv-icon512x512.png';

class BatchShipmentDateUpload extends React.Component {

	constructor(props) {
    super(props);

    this.state = {
			errorMsg: null,
			saveErrors: [],
			validated: false,
			importResult: null,
			isUploadingFile: false,
			isSavingDates: false,
			loadedSerialBatch: false,
			selectedFileSerialBatch: null,
			parsedCSVData: [],
			productType: PRODUCT_TYPE_EVO,
			currentUser: props.currentUser || JSON.parse(localStorage.getItem('currentUser')),
	  };

  }

	onClickUploadSerialBatchHandler = () => {

		const file = this.state.selectedFileSerialBatch;

    if (!file) {
			this.setState({ errorMsg: 'Please select a CSV file.' });
      //setErrorMsg('Please select a CSV file.');
      return;
    }

		if (this.state.isUploadingFile || this.state.isSavingDates) return;
		this.setState({ isUploadingFile: true, errorMsg: null, saveErrors: [], validated: false, importResult: null });

		Papa.parse(file, {
			header: true,
			dynamicTyping: false,
			skipEmptyLines: true,
			complete: async (result) => {
				if (result.errors.length > 0) {
					this.setState({
						errorMsg: 'Error parsing the CSV file.',
						parsedCSVData: [],
						isUploadingFile: false
					});
				} else {
					const missingHeaders = validateShipmentDateHeaders(result.meta && result.meta.fields);

					if (missingHeaders.length > 0) {
						this.setState({
							errorMsg: `CSV is missing required column${missingHeaders.length > 1 ? 's' : ''}: ${missingHeaders.join(', ')}.`,
							parsedCSVData: [],
							isUploadingFile: false
						});
						return;
					}

					const formattedCSVData = buildShipmentDateRows(result.data, this.state.productType);
					await this.validateShipmentRows(formattedCSVData);

				}
			},
			error: () => {
				this.setState({
					errorMsg: 'Error parsing the CSV file.',
					parsedCSVData: [],
					isUploadingFile: false
				});
			}
		});

	}

	onChangeSerialBatchHandler = (event) => {
		if (this.state.isSavingDates || this.state.isUploadingFile) return;
		const selectedFile = event.target.files && event.target.files[0];

		if (!selectedFile) {
			this.setState({
				selectedFileSerialBatch: null,
				loadedSerialBatch: false,
				parsedCSVData: [],
				saveErrors: [],
				validated: false,
				importResult: null,
				errorMsg: null
			});
			return;
		}

		this.setState({
			selectedFileSerialBatch: selectedFile,
			loadedSerialBatch: true,
			parsedCSVData: [],
			saveErrors: [],
			validated: false,
			importResult: null,
			errorMsg: null
		})
	}

	selectProductType = productType => {
		if (this.state.isSavingDates || this.state.isUploadingFile) return;
		if (parseInt(productType) === parseInt(this.state.productType)) return;

		const fileInput = document.getElementById('fileSerialBatch');
		if (fileInput) fileInput.value = null;

		this.setState({
			productType,
			saveErrors: [],
			validated: false,
			importResult: null,
			selectedFileSerialBatch: null,
			loadedSerialBatch: false,
			parsedCSVData: [],
			errorMsg: null
		});
	}

	filterCaseInsensitive = (filter, row) => {
		const rowValue = row[filter.pivotId || filter.id];
		return rowValue !== undefined && rowValue !== null
			? String(rowValue).toLowerCase().indexOf(String(filter.value).toLowerCase()) !== -1
			: false;
	}

	requestShipmentDates = async requestBody => {
		const url = process.env.REACT_APP_SHIPMENT_DATE_API_URL || "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com" + process.env.REACT_APP_ENV + "save-batch-shipment-dates";
		const response = await fetch(url, {
			method: 'POST',
			headers: { Authorization: this.state.currentUser.jwtToken, 'Content-Type': 'application/json' },
			body: JSON.stringify(requestBody)
		});
		const body = await response.json();
		return { ok: response.ok, body };
	};

	validateShipmentRows = async rows => {
		this.setState({ parsedCSVData: rows, validated: false, errorMsg: null, importResult: null, saveErrors: [], isUploadingFile: true });
		const eligible = rows.filter(row => row.IsValid);
		if (!eligible.length || this.state.productType === PRODUCT_TYPE_NOVA) {
			this.setState({ validated: true, isUploadingFile: false });
			return;
		}
		try {
			// A separate field makes older APIs reject this check before writing.
			const { ok, body } = await this.requestShipmentDates({
				ProductID: this.state.productType,
				ValidateShipmentDatesList: getShipmentDateRequestBody(eligible, this.state.productType).ProtectedShipmentDatesList
			});
			if (!ok || body.status !== 'Validated' || !Array.isArray(body.rowErrors)) throw new Error('Validation unavailable');
			const saveErrors = getShipmentDateSaveErrors(body);
			this.setState({ parsedCSVData: applyShipmentDateSaveErrors(rows, saveErrors), saveErrors, validated: true });
		} catch (_) {
			this.setState({ errorMsg: 'Unable to check existing ship dates. Nothing was imported. Click Upload to retry before submitting.' });
		} finally {
			this.setState({ isUploadingFile: false });
		}
	};

	saveShipmentDatesData = async () => {
		if (this.state.isSavingDates || this.state.isUploadingFile || !this.state.validated) return;
		const eligible = this.state.parsedCSVData.filter(row => row.IsValid && !row.IsImported);
		if (!eligible.length) return;
		this.setState({ isSavingDates: true, errorMsg: null });
		try {
			const { ok, body } = await this.requestShipmentDates(getShipmentDateRequestBody(eligible, this.state.productType));
			if (ok && body.status === 'Success') {
				const excluded = this.state.parsedCSVData.filter(row => !row.IsValid).length;
				this.setState({
					parsedCSVData: this.state.parsedCSVData.map(row => eligible.includes(row) ? { ...row, IsImported: true, Status: 'Imported' } : row),
					importResult: `${eligible.length} shipment date${eligible.length === 1 ? '' : 's'} imported. ${excluded} row${excluded === 1 ? '' : 's'} excluded.`,
					loadedSerialBatch: false,
					selectedFileSerialBatch: null
				});
				const fileInput = document.getElementById('fileSerialBatch');
				if (fileInput) fileInput.value = null;
				toast.success('Shipment dates imported successfully.');
			} else {
				const errors = getShipmentDateSaveErrors(body);
				this.setState({
					saveErrors: [...this.state.saveErrors, ...errors],
					parsedCSVData: applyShipmentDateSaveErrors(this.state.parsedCSVData, errors),
					errorMsg: errors.length ? 'Some dates changed since this file was checked. Nothing was imported. Review the new exclusions and submit the remaining eligible rows.' : 'Unable to confirm the import. Check the current shipment dates before retrying.',
					validated: errors.length > 0
				});
			}
		} catch (_) {
			this.setState({ validated: false, errorMsg: 'Unable to confirm the import. Check the current shipment dates before retrying.' });
		} finally {
			this.setState({ isSavingDates: false });
		}
	};

		render() {
		const excludedCount = this.state.parsedCSVData.filter(row => !row.IsValid).length;
		const eligibleCount = this.state.parsedCSVData.filter(row => row.IsValid && !row.IsImported).length;
		const selectedProductName = this.state.productType === PRODUCT_TYPE_NOVA ? 'Nova' : 'EVO';

		const data = this.state.parsedCSVData.map((prop, key) => {

			return {
				id: key,
				SerialNumber: prop.SerialNumber,
				InvoiceDate: prop.InvoiceDate,
				ExistingShipmentDate: prop.ExistingShipmentDate,
				Product: selectedProductName,
				Status: prop.Status,
				IsValid: prop.IsValid,
				IsImported: prop.IsImported
			};
		});

		return (
      <Fragment>
        <Card className="card-hover">
          <CardBody>
            <Row className="mb-3">
              <Col md="12">
                <h3 style={{color:'#737782'}}>Purchase Date Upload</h3>
              </Col>
            </Row>
						<Row className="mb-3">
							<Col xs="12" sm="6" md="4" lg="3">
								<ButtonGroup style={{ width: '100%' }} aria-label="Shipment date product">
									<Button
										style={{width: '100%'}}
										size="sm"
										color="btngray"
										active={this.state.productType === PRODUCT_TYPE_EVO}
										aria-pressed={this.state.productType === PRODUCT_TYPE_EVO}
										disabled={this.state.isSavingDates || this.state.isUploadingFile}
										onClick={() => this.selectProductType(PRODUCT_TYPE_EVO)}
									>
										EVO
									</Button>
									<Button
										className="ml-1"
										style={{width: '100%'}}
										size="sm"
										color="btngray"
										active={this.state.productType === PRODUCT_TYPE_NOVA}
										aria-pressed={this.state.productType === PRODUCT_TYPE_NOVA}
										disabled={this.state.isSavingDates || this.state.isUploadingFile}
										onClick={() => this.selectProductType(PRODUCT_TYPE_NOVA)}
									>
										Nova
									</Button>
								</ButtonGroup>
							</Col>
						</Row>
						{this.state.productType === PRODUCT_TYPE_EVO && <p className="text-muted">
							Rows with an existing EVO original ship date are highlighted and excluded. Review the reasons below, then import only the eligible rows.
						</p>}
						{!this.state.isUploadingFile ? (
							<Fragment>
							<Row className="align-items-center">
								<Col xs="12" md="5" lg="4">
									<Input className="" type="file" name="fileSerialBatch" id="fileSerialBatch" accept=".csv" disabled={this.state.isSavingDates || this.state.isUploadingFile} onChange={this.onChangeSerialBatchHandler} onClick={e => (e.target.value = null)}/>
									{this.state.selectedFileSerialBatch && <small className="d-block mt-2" style={{ overflowWrap: 'anywhere' }}>Reviewing: {this.state.selectedFileSerialBatch.name}</small>}
								</Col>
								<Col xs="12" md="3" lg="3" className="mt-2 mt-md-0">
									{this.state.loadedSerialBatch &&
										<Fragment>
											<Button className="" size="sm" color="yellow" title="Upload" disabled={this.state.isUploadingFile || this.state.isSavingDates} onClick={this.onClickUploadSerialBatchHandler}>
												Upload
											</Button>
											<img style={{ marginTop: "-3px"}} className="ml-2" src={csvPlaceholder} width="30" alt="Selected CSV file"/>
										</Fragment>
									}
								</Col>
								<Col xs="12" md="4" lg="5" className="mt-2 mt-md-0">
								{!this.state.isSavingDates ? (
									<Fragment>
										{this.state.parsedCSVData.length > 0 && !this.state.importResult &&
										<Button className="float-right" size="" color="yellow" title="Import eligible shipment dates" disabled={!eligibleCount || !this.state.validated || this.state.isUploadingFile || this.state.isSavingDates} onClick={this.saveShipmentDatesData}>
											{`Import ${eligibleCount} eligible row${eligibleCount === 1 ? '' : 's'}`}
											</Button>
										}
									</Fragment>
								) : (
									<Fragment>
										<Row className="pl-4 float-right">
												<Fade in="true">
													<Row className="justify-content-center">
														<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
													</Row>
												</Fade>
										</Row>
									</Fragment>
								)}
								</Col>
							</Row>
							<Row className="pt-3">
								<Col xs="12">
									{this.state.importResult && <Alert fade={false} color="success" role="status">{this.state.importResult}</Alert>}
									{this.state.parsedCSVData.length > 0 && !this.state.importResult && <p role="status">
										{this.state.validated ? `${eligibleCount} eligible · ${excludedCount} excluded. ${eligibleCount ? 'Only eligible rows will be imported.' : 'No eligible rows. Select another file to continue.'}` : 'Ship date check required before import.'}
									</p>}
									{excludedCount > 0 && <Alert fade={false} color="warning" className="mb-3">Highlighted rows are excluded from the import. The Status column explains why. Existing ship dates will be preserved.</Alert>}
									{this.state.errorMsg && <Alert fade={false} color="danger" role="alert" className="mb-0">
										<div>{this.state.errorMsg}</div>
										{this.state.saveErrors.length > 0 && <ul className="mt-2 mb-0 pl-3" aria-label="Shipment date errors" style={{ maxHeight: 240, overflowY: 'auto' }}>
											{this.state.saveErrors.map((error, index) => <li key={`${error.SerialNumber}-${index}`}>
												<strong>{error.SerialNumber}</strong> — {error.message}
												{error.ExistingShipmentDate && ` Original ship date: ${Moment(error.ExistingShipmentDate, 'YYYY-MM-DD', true).isValid() ? Moment(error.ExistingShipmentDate, 'YYYY-MM-DD').format('MM/DD/YYYY') : error.ExistingShipmentDate}.`}
											</li>)}
										</ul>}
									</Alert>}
								</Col>
							</Row>
							</Fragment>
						) : (
							<Row className="pl-4 pl-4">
									<Fade in="true">
										<Row className="justify-content-center">
											<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
										</Row>
									</Fade>
							</Row>
						)}
          </CardBody>


        </Card>
				<Card className="card-hover">
          <CardBody>
						<div className="table-responsive">
						<ReactTable
							style={{backgroundColor:'#000', color:'#e6e6e6', padding:'10px', minWidth: '700px', autocomplete: 'none'}}
							columns={[
								{
									Header: "Product",
									accessor: "Product",
									width: 110,
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
										<div style={{ textAlign: "center" }}>{row.value}</div>
									)
								},
								{
									Header: "Serial Number",
									accessor: "SerialNumber",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
											<div style={{ textAlign: "center" }}>{row.value}</div>
										)
								},
								{
									Header: "Invoice Date",
									accessor: "InvoiceDate",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									Cell: row => (
											<div style={{ textAlign: "center" }}>{Moment(row.value, 'YYYY-MM-DD', true).isValid() ? Moment(row.value, 'YYYY-MM-DD').format('MM/DD/YYYY') : row.value}</div>
										)
								},
								{
									Header: "Existing Ship Date",
									accessor: "ExistingShipmentDate",
									show: this.state.saveErrors.some(error => error.ExistingShipmentDate),
									width: 170,
									Cell: row => <div style={{ textAlign: 'center' }}>{row.value
										? (Moment(row.value, 'YYYY-MM-DD', true).isValid() ? Moment(row.value, 'YYYY-MM-DD').format('MM/DD/YYYY') : row.value)
										: '—'}</div>
								},
								{
									Header: "Status",
									accessor: "Status",
									minWidth: 260,
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center', whiteSpace: 'normal', overflowWrap: 'anywhere'},
									Cell: row => (
										<div style={{ color: !row.original.IsValid ? '#ffb5bc' : '#5cb85c', textAlign: "center" }}>{row.value}</div>
									)
								},
							]}
							defaultPageSize={15}
							sortable={true}
							showPaginationBottom={true}
							className="-striped -highlight"
							data={data}
							filterable
							filterAll={true}
							defaultFilterMethod={(filter, row) => this.filterCaseInsensitive(filter, row) }
							getTrGroupProps={(state, rowInfo) => rowInfo && !rowInfo.original.IsValid ? {
								style: { backgroundColor: '#421f25', boxShadow: 'inset 4px 0 #ff7b86' },
								'aria-label': `Excluded: ${rowInfo.original.SerialNumber}`
							} : {}}
						/>
						</div>
					</CardBody>
        </Card>
				<ToastContainer/>
      </Fragment>
		);
	}
}

export default BatchShipmentDateUpload;
